import { Component, OnInit, ViewChild } from '@angular/core';
import { DropDownService } from '../../Services/DropDown/dropdownService';
import { RegionModel, RMHModel } from '../../models/DropDwon/RegionModel';
import { ZoneModel } from '../../models/DropDwon/ZoneModel';
import { DivisionModel } from '../../models/DropDwon/DvisionModel';
import { SBUModel } from '../../models/DropDwon/SBUModel';
import { DropDownRequest, DropDownResponse, WHLocationModel, SDModel, RequirmentTypeModel, StatusModel } from '../../models/DropDwon/DropDownRequest';
import { productModel } from '../../models/DropDwon/ProductModel';
import { CropModel } from '../../models/DropDwon/CropModel';
import { ToastrService } from 'ngx-toastr';
import { DSCostApprovalService } from '../../Services/DSCostApproval/ds-costapproval.service';
import { SaveCostApproval } from '../../Models/DSCostApproval/SaveCostApproval';
import { parse } from 'querystring';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';
import { $ } from 'protractor';
import { YearModel } from 'src/app/Models/DropDwon/YearModel';
import { P } from '@angular/core/src/render3';


@Component({
  selector: 'app-ds-cost-approval',
  templateUrl: './ds-cost-approval.component.html',
  styleUrls: ['./ds-cost-approval.component.css']
})
export class DsCostApprovalComponent implements OnInit {

  displayedColumns = ['requirementType','rmhName', 'productName', 'finalProductQtyApproved','approvedOn', 'comment','year'];
  dataSource: MatTableDataSource<CostApprovalHistoyData>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('regionSelect') regionSelect;
  @ViewChild('sd') sd;
  @ViewChild('warehouseLocation') warehouseLocation;
  @ViewChild('sbu') sbu;
  @ViewChild('division') division;
  @ViewChild('zone') zone;
  @ViewChild('rmh') rmh;
  @ViewChild('productSelect') productSelect;
  @ViewChild('CropSelect') CropSelect;
  @ViewChild('cropSelect') cropSelect;
  //@ViewChild('requirmentType') requirmentType;
  @ViewChild('status') status;
  @ViewChild('file') file;
  @ViewChild('yearSelect') yearSelect;
  @ViewChild('year') year;
  

  public requirmentType:any=[];
  public dropdownMonthSettings: {};

  public ProductSettings = {};
  public ProductSelectedItem: productModel[];

  public CropSettings = {};
  public CropSelectedItem: CropModel[];

  public RMHSettings = {};
  public RMHSelectedItems: RMHModel[];


  public RegionSettings = {};
  public RegionselectedItems: RegionModel[];

  public SBUSettings = {};
  public SBUSelectedItem: SBUModel[];

  public DivisionSettings = {};
  public DivisionSelectedItem: DivisionModel[];

  public ZoneSettings = {};
  public ZoneSelectedItem: ZoneModel[];
  
  public YearSettings= {};
  public YearSelectedItem: YearModel[];

  public userId: string;
  public roleId: string;
  public FlagDropDown: string;

  public ddlRequest: DropDownRequest = new DropDownRequest();
  public ddlResponse: DropDownResponse = new DropDownResponse();

  public RequirmentTypeSettings = {};
  public RequirmentTypeSettingsForAdmin = {};
  public requirmentTypeDdl: RequirmentTypeModel[];
  public requirmentDllValue: any;

  public WHLocationSettings = {};
  public whLocationDdl: WHLocationModel[];
  public whLocationDDlValue: any;

  approvefinalReqDetails: any[] = [];
  reqType: string;
  regionCode: string;
  wareHouseLocation: string;
  selectedReqType: string;
  selectedRegion: any[] = [];
  selectedSbu: any[] = [];
  selectedDivision: any[] = [];
  selectedZone: any[] = [];
  commaSeperatedSbus: string;
  commaSeperatedDivisions: string;
  commaSeperatedZones: string;
  commaSeperatedRegions: string;
  commaSeperatedSDs: string;
  selectedSDs: any[] = [];
  public SDSettings = {};
  public WarehouseLocationSettings = {};
  public loader: string = "none";
  public files: File[] = [];
  public fileName: string = '';
  public whlocationList: WHLocationModel[];

  defaultView: boolean = true;
  tableView: boolean = false;
  dsCostObj: any = [];
  dsCostInventoryObj: any = [];
  dsCostHistoryObj: any = [];
  singleSaveCostApprove: SaveCostApproval = new SaveCostApproval();
  selectedSaveCostApprove: any[] = [];
  newSaveCostApprove: SaveCostApproval = new SaveCostApproval();
  userName: string;
  approveEnable = false;
  finalApprove: any = [];
  displayReject = 'none';
  calStockAvaliable: any = [];
  defaultValue = 'none';
  selectedStatus: string;
  approveDisable: any = false;
  public StatusSettings = {};
  public statusDdl: StatusModel[];
  public statusDllValue: any;
  tabName: string = "Volume";
  defaultValueCrop = 'none';
  dsCostObjCrop: any = [];
  defaultValueProduct = 'none';
  isProduct: boolean = true;
  
//deepanshu code start
currentPageForHistory: any;
lastPageForHistory:any;
totalRecordForHistory:any;
recordsOnCurrentPageForHistory: number = 0;
startRecordForHistory:number=1;

isDisabledPreviousForHistory=true;
isDisabledNextForHistory=true;
endRecordForHistory: number;
//deepansh

  constructor(private ddlServices: DropDownService, private toastr: ToastrService, private dsCostServices: DSCostApprovalService) {
    this.userId = localStorage.getItem('dsu_userId');
    this.roleId = localStorage.getItem('dsu_roleId');
    this.userName = localStorage.getItem('dsu_userName');
    this.FlagDropDown = (this.roleId == "39" || this.roleId == "43" || this.roleId == "44") ? "DEFAULT" : "DEFAULT";
    

  }
 

  ngOnInit() {
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.tabName = 'ProductWise';

    this.ddlServices.getAllHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse = response.data;
          this.ddlResponse.year=response.data.year;
          class YearItemList{
            id: any;
            text: any;
        }
          let requiredItem: YearItemList[] = [];
          var obj = {
            id : this.ddlResponse.year[0].currentrequirementYear,
            text: this.ddlResponse.year[0].currentrequirementYear
          }
          requiredItem.push(obj)
          this.year.selectedItems = requiredItem
          // for(var i=0;i<this.year.selectedItems.length; i++){
          //     this.yearSelect.push(this.year.selectedItems[i].text)
          // }
        this.YearSetting();          
        this.GetWarehouseLocationData();
        }
        else {
          this.toastr.error(response.message);
        }

      }, error => {
      });
    this.SBUMHSetting();
    this.DivisionSetting();
    this.ZoneSetting();
    this.RegionSetting();
    // this.requirmentTypeDdl = [{ id: 1, text: "Annual" }, { id: 2, text: "Additional" }];
    this.requirmentTypeDdl = [{ id: 1, text: "H1" },{ id: 2, text: "H2" }, { id: 3, text: "Additional" }];
    this.statusDdl = [{ id: 1, text: "Approved" }, { id: 2, text: "Approval Pending" }, {id:3, text:"Partially Approved" }, {id:4, text:"Expired" }, {id:5, text:"Rejected by BM" }];
    this.RequirmentTypeSetting();
    this.RMHSetting();
    this.SDSetting();
    this.WareHouseLocationSetting();
    this.CropSetting();
    this.ProductSetting();
    this.StatusSetting();
    this.YearSetting();
    //this.requirmentType.push(this.requirmentTypeDdl[0]);
    this.requirmentType.push({ 'id': 1, 'text': "H1" });
    this.onReqTypeSelect(this.requirmentType);
    
    
    
  }

  RegionSetting() {
    this.RegionSettings = {
      singleSelection: true,
      idField: 'regionCode',
      textField: 'regionName',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: false,
      //maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Region Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  CropSetting() {
    this.CropSettings = {
      singleSelection: false,
      idField: 'cropId',
      textField: 'cropName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Crop Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  ProductSetting() {
    this.ProductSettings = {
      singleSelection: false,
      idField: 'productId',
      textField: 'productName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Product Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  RMHSetting() {
    this.RMHSettings = {
      singleSelection: false,
      idField: 'rmhCode',
      textField: 'rmhName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      //maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No RMH Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  WareHouseLocationSetting() {
    this.WarehouseLocationSettings = {
      singleSelection: false,
      idField: 'whId',
      textField: 'whName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Warehouse Location Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  
  YearSetting(){
    this.YearSettings = {
      singleSelection: true,
      idField: 'year',
      textField: 'year',
      enableCheckAll: false,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: false,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Year Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
}
  SBUMHSetting() {
    this.SBUSettings = {
      singleSelection: false,
      idField: 'sbuCode',
      textField: 'sbuName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No SBU Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  DivisionSetting() {
    this.DivisionSettings = {
      singleSelection: false,
      idField: 'divisionCode',
      textField: 'divisionName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Division Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  ZoneSetting() {
    this.ZoneSettings = {
      singleSelection: false,
      idField: 'zoneCode',
      textField: 'zoneName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Zone Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  StatusSetting() {
    this.StatusSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'text',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Status Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  RequirmentTypeSetting() {
    this.RequirmentTypeSettings = {
      singleSelection: true,
      idField: 'id',
      textField: 'text',
      enableCheckAll: true,
      //selectAllText: 'Select All',
      //unSelectAllText: 'UnSelect All',
      allowSearchFilter: false,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Requirment Type Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }
  RequirmentTypeSettingForAdmin() {
    this.RequirmentTypeSettingsForAdmin = {
      singleSelection: false,
      idField: 'id',
      textField: 'text',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Requirment Type Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
      
    };
  }
  WHLocationSetting() {
    this.WHLocationSettings = {
      singleSelection: true,
      idField: 'WHId',
      textField: 'WHName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Location Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }


  public onSBUSelect(item: any) {
    this.selectedSbu = [];
    for (var i = 0; i < this.sbu.selectedItems.length; i++) {
      this.selectedSbu.push(this.sbu.selectedItems[i].id)
    }
    this.commaSeperatedSbus = this.selectedSbu.join(", ");
    this.GetSBUWiseData(this.sbu.selectedItems);
  }
  public onSBUDeSelect(item: any) {
    this.selectedSbu = [];
    for (var i = 0; i < this.sbu.selectedItems.length; i++) {
      this.selectedSbu.push(this.sbu.selectedItems[i].id)
    }
    this.commaSeperatedSbus = this.selectedSbu.join(", ");

    this.GetSBUWiseData(this.sbu.selectedItems);
  }

  public onSBUSelectAll(items: any) {
    this.selectedSbu = [];
    for (var i = 0; i < this.sbu.selectedItems.length; i++) {
      this.selectedSbu.push(this.sbu.selectedItems[i].id)
    }
    this.commaSeperatedSbus = this.selectedSbu.join(", ")
    this.GetSBUWiseData(this.sbu.selectedItems);
  }
  public onSBUDeSelectAll(items: any) {
    this.selectedSbu = [];
    this.commaSeperatedSbus = '';
    this.GetSBUWiseData(this.sbu.selectedItems);
  }

  public onDivisionSelect(item: any) {
    this.selectedDivision = []
    for (var i = 0; i < this.division.selectedItems.length; i++) {
      this.selectedDivision.push(this.division.selectedItems[i].id)
    }
    this.commaSeperatedDivisions = this.selectedDivision.join(", ");
    this.GetDivisionWiseData(this.division.selectedItems);

  }
  public onDivisionDeSelect(item: any) {
    this.selectedDivision = []
    for (var i = 0; i < this.division.selectedItems.length; i++) {
      this.selectedDivision.push(this.division.selectedItems[i].id)
    }
    this.commaSeperatedDivisions = this.selectedDivision.join(", ")
    this.GetDivisionWiseData(this.division.selectedItems);
  }

  public onDivisionSelectAll(items: any) {
    this.selectedDivision = []
    for (var i = 0; i < this.division.selectedItems.length; i++) {
      this.selectedDivision.push(this.division.selectedItems[i].id)
    }
    this.commaSeperatedDivisions = this.selectedDivision.join(", ")
    this.GetDivisionWiseData(this.division.selectedItems);
  }
  public onDivisionDeSelectAll(items: any) {
    this.selectedDivision = [];
    this.commaSeperatedDivisions = '';
    this.GetDivisionWiseData(this.division.selectedItems);
  }

  public onZoneSelect(item: any) {
    this.selectedZone = [];
    for (var i = 0; i < this.zone.selectedItems.length; i++) {
      this.selectedZone.push(this.zone.selectedItems[i].id)
    }
    this.commaSeperatedZones = this.selectedZone.join(", ");
    this.GetZoneWiseData(this.zone.selectedItems);
  }
  public onZoneDeSelect(item: any) {
    this.selectedZone = [];
    for (var i = 0; i < this.zone.selectedItems.length; i++) {
      this.selectedZone.push(this.zone.selectedItems[i].id)
    }
    this.commaSeperatedZones = this.selectedZone.join(", ");
    this.GetZoneWiseData(this.zone.selectedItems);
  }

  public onZoneSelectAll(items: any) {
    this.selectedZone = [];
    for (var i = 0; i < this.zone.selectedItems.length; i++) {
      this.selectedZone.push(this.zone.selectedItems[i].id)
    }
    this.commaSeperatedZones = this.selectedZone.join(", ");
    this.GetZoneWiseData(this.zone.selectedItems);
  }
  public onZoneDeSelectAll(items: any) {
    this.selectedZone = [];
    this.commaSeperatedZones = '';
    this.GetZoneWiseData(this.zone.selectedItems);
  }
  SDSetting() {
    this.SDSettings = {
      singleSelection: true,
      idField: 'sdCode',
      textField: 'sdName',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No WH Found',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
  }

  bindMonthDropdownSetting() {
    this.dropdownMonthSettings = {
      singleSelection: false,
      text: "Select Month",
      idField: 'Id',
      textField: 'Text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: true,
      noDataAvailablePlaceholderText: 'No Month Found'
    };
  }


  GetSBUWiseData(filter: any) {
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.IsBMData=true;
    this.ddlRequest.SBU = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getSBUHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.division = response.data.division;
          this.ddlResponse.zone = response.data.zone;
          this.ddlResponse.region = response.data.region;
          this.ddlResponse.rmh = response.data.rmh;
          this.division.selectedItems = response.data.division.map(item => { return { id: item.divisionCode, text: item.divisionName } });
          this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
        }
        else {
          this.toastr.error(response.message);
        }

      }, error => {

      });
  }
  GetDivisionWiseData(filter: any) {
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.Division = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getDivisionHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.region = response.data.region;
          this.ddlResponse.zone = response.data.zone;
          this.ddlResponse.rmh = response.data.rmh;

          this.zone.selectedItems = response.data.zone.map(item => { return { id: item.zoneCode, text: item.zoneName } });
          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
        }
        else {
          this.toastr.error(response.message);
        }

      }, error => {

      });
  }
  GetZoneWiseData(filter: any) {
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.Zone = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getZoneHierarchyDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.region = response.data.region;
          this.ddlResponse.rmh = response.data.rmh;

          this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
        }
        else {
          this.toastr.error(response.message);
        }

      }, error => {

      });
  }

  onReqTypeSelect(item: any) {
    this.selectedReqType = item.text
      this.RequirmentTypeSetting();
  }

  onReqTypeSelectAdmin(item: any){
    this.selectedReqType = item.text
    this.RequirmentTypeSettingForAdmin();
  }
  
  onReqTypeDeSelect(item: any) {
    this.selectedReqType = '';
  }

  onStatusSelect(item: any) {
    this.selectedStatus = item.text
    this.StatusSetting();
  }
  onStatusDeSelect(item: any) {
    this.selectedStatus = '';
  }
  public onRegionSelect(item: any) {
    this.selectedRegion = [];
    for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
      this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
    }
    this.commaSeperatedRegions = this.selectedRegion.join(", ");

    this.GetRegionWiseData(this.regionSelect.selectedItems);
  }
  public onRegionDeSelect(item: any) {
    this.selectedRegion = [];
    for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
      this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
    }
    this.commaSeperatedRegions = this.selectedRegion.join(", ");

    this.GetRegionWiseData(this.regionSelect.selectedItems);
  }

  public onRegionSelectAll(items: any) {
    this.selectedRegion = [];
    for (var i = 0; i < this.regionSelect.selectedItems.length; i++) {
      this.selectedRegion.push(this.regionSelect.selectedItems[i].id)
    }
    this.commaSeperatedRegions = this.selectedRegion.join(", ");
  }
  public onRegionDeSelectAll(items: any) {
    this.selectedRegion = [];
    this.commaSeperatedRegions = '';
  }
  GetRegionWiseData(filter: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.Region = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getRegionWiseRMHDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          // this.ddlResponse.rmh = response.data.rmh;
          if (response.data.rmh.length > 0)
            this.rmh.selectedItems = response.data.rmh.map(item => { return { id: item.rmhCode, text: item.rmhName } });
          else
            this.rmh.selectedItems = [];
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {

        this.loader = 'none';
      });
  }
  public onRMHSelect(item: any) {
    this.GetRMHWiseData(this.rmh.selectedItems);
    this.getSDRMHWise(this.rmh.selectedItems);
    //this.getWHRMHWise(this.rmh.selectedItems);
  }
  public onRMHDeSelect(item: any) {
    this.GetRMHWiseData(this.rmh.selectedItems);
    this.getSDRMHWise(this.rmh.selectedItems);
    //this.getWHRMHWise(this.rmh.selectedItems);

  }

  public onRMHSelectAll(items: any) {
    this.GetRMHWiseData(this.rmh.selectedItems);
    this.getSDRMHWise(this.rmh.selectedItems);
    //this.getWHRMHWise(this.rmh.selectedItems);

  }
  public onRMHDeSelectAll(items: any) {
    this.GetRMHWiseData(this.rmh.selectedItems);
    this.getSDRMHWise(this.rmh.selectedItems);
    // this.getWHRMHWise(this.rmh.selectedItems);

  }
  GetRMHWiseData(filter: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.RMH = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getRMHWiseRegionDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.region = response.data.region;
          
          class RegionItemList{
            id: any;
            text: any;
        }
          let requiredItem: RegionItemList[] = [];
          var obj = {
            id : this.ddlResponse.region[0].regionCode,
            text: this.ddlResponse.region[0].regionName
          }
          requiredItem.push(obj)
          this.regionSelect.selectedItems = requiredItem;
          for(var i=0;i< this.regionSelect.selectedItems.length; i++){
              this.regionSelect.push(this.regionSelect.selectedItems[i].text)
          }
         this.RegionSetting();    

          //this.regionSelect.selectedItems = response.data.region.map(item => { return { id: item.regionCode, text: item.regionName } });
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {

        this.loader = 'none';
      });
  }
  getSDRMHWise(filter: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.RMH = Array.prototype.map.call(filter, function (item) { return item.id; }).join(",");
    this.ddlServices.getSDRMHWise(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.sd = response.data.sd;
          this.getWHRMHWise(this.ddlRequest.RMH, this.ddlResponse.sd)
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }
  getWHRMHWise(filter: any, filterSD: any) {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = this.FlagDropDown;
    this.ddlRequest.RMH = filter;
    this.ddlRequest.SD = Array.prototype.map.call(filterSD, function (item) { return item.sdCode; }).join(",");
    this.ddlServices.getWHRMHWise(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.warehouseLocation = response.data.warehouse;
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }

  GetWarehouseLocationData() {
    this.loader = 'block';
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlRequest.Flag = 'TRUE';
    this.ddlServices.getWarehouseLocationDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.warehouseLocation = response.data.warehouse;
          this.loader = 'none';
        }
        else {
          this.toastr.error(response.message);
          this.loader = 'none';
        }

      }, error => {
        this.loader = 'none';
      });
  }
  GetSDData() {
    this.ddlRequest.UserId = this.userId;
    this.ddlRequest.Role = this.roleId;
    this.ddlServices.getSDDropDown(this.ddlRequest)
      .subscribe((response) => {
        if (response.status) {
          this.ddlResponse.sd = response.data.sd;
        }
        else {
          this.toastr.error(response.message);
        }

      }, error => {
      });
  }
  ConvertToCurrency(value:any)
  {
      var parts = value.toString().replace(',','').split(".");
      if(parts[0].length > 3){
      parts[0] = parts[0].slice(0,parts[0].length-3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") +','+ parts[0].slice(parts[0].length-3,parts[0].length);
      }
      return parts.join(".");
  }


  GetCostApproval(currentPageForHistory: number) {
    debugger;
    this.defaultValueCrop = 'none';
    this.userId = localStorage.getItem('dsu_userId');
    let region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
    let rmh = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
    let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
    let crop = "";
    let year=0;
   // let requirmentType="";
    let requirmentType=this.requirmentType[0].text;
    crop=Array.prototype.map.call(this.CropSelect.selectedItems, function (item) { return item.id; }).join(",");
   
 
    //let crop=Array.prototype.map.call(this.cropSelect.selectedItems, function (item) { return item.id; }).join(",");
    // if(this.requirmentType.length>1){
    //   requirmentType='1,2';
    // }
    // else{  
    //   requirmentType = this.requirmentType[0].id;//Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.id; }).join(",");
    // }

    let status = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.id; }).join(",");
    let whCode = Array.prototype.map.call(this.warehouseLocation.selectedItems, function (item) { return item.id; }).join(",");
    year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    let isValid = true;

    if (typeof (requirmentType) == "undefined" || requirmentType == '' || requirmentType=="") {
      this.toastr.error('Please select requirement type.');
      isValid = false;
      return false;
    }

    if (isValid) {
     if(this.tabName=='ProductWise')
     {
        this.isProduct=true;
     }
     else{
      this.isProduct=false;
     }
      this.approveEnable = false;
      this.loader = 'block';
      this.dsCostServices.GetCostApproval(currentPageForHistory,region, rmh, requirmentType, product, crop, this.userId, status, whCode,this.isProduct,year)
        .subscribe((response) => {
          debugger;
          //deepanshu code start
          this.loader = 'block';
          this.isDisabledPreviousForHistory = true;
          this.isDisabledNextForHistory = false;
          this.startRecordForHistory=1;
          let region="";
          let currentpageForHistory = currentPageForHistory;
          //deeapnshu code end
         console.log(response);
         debugger;
         console.log(response.data.costapprovalmodel);
          if (response.status) {
            this.tableView = true;
            this.defaultView = false;
            debugger;
            this.defaultValue = 'block';
            this.defaultValueProduct = 'block';
            //this.dsCostObj = response.data;
            if (this.tabName == 'ProductWise') {
            this.dsCostObj = response.data.costapprovalmodel;
            this.dsCostInventoryObj = response.data.inventoryModel;
            this.dsCostHistoryObj = response.data.historyModel;
            console.log(this.dsCostHistoryObj);
//deepanshu code start

if(response.data == null){
  this.startRecordForHistory = 0;
  this.recordsOnCurrentPageForHistory = 0;
  this.totalRecordForHistory = 0;
  this.isDisabledNextForHistory = true;
  this.endRecordForHistory = 0;
}
else{
  this.totalRecordForHistory=response.data.pdataModel[0].totalRecord
  this.currentPageForHistory= response.data.pdataModel[0].currentPage; 
  this.lastPageForHistory = response.data.pdataModel[0].lastPage;
  this.recordsOnCurrentPageForHistory =response.data.pdataModel[0].recordOnPage
  this.endRecordForHistory = this.recordsOnCurrentPageForHistory;
  if (this.currentPageForHistory == 1)
  {
     
      localStorage.setItem("numberOfRecordsOnFirstPageForHistory", this.recordsOnCurrentPageForHistory.toString());
  }
  if (this.currentPageForHistory > 1)
  {
      this.isDisabledPreviousForHistory = false;
      // this.startRecordForHistory = (this.currentPageForHistory - 1) * (approvalData.data.length) + 1;
      this.startRecordForHistory = (this.currentPageForHistory - 1) * parseInt(localStorage.getItem("numberOfRecordsOnFirstPageForHistory"), 10) + 1;
      this.endRecordForHistory = this.startRecordForHistory + this.recordsOnCurrentPageForHistory - 1;
  }
  if (this.currentPageForHistory == this.lastPageForHistory || this.totalRecordForHistory == 0) {
      this.isDisabledNextForHistory = !this.isDisabledNextForHistory;
      this.recordsOnCurrentPageForHistory = this.totalRecordForHistory;
  }
}
//deepanshu code ne

            if(this.dsCostHistoryObj!=null){
            // Assign the data to the data source for the table to render
          this.dataSource = new MatTableDataSource(this.dsCostHistoryObj);
     

          setTimeout(() => {
            this.dataSource.sort = this.sort;
            this.dataSource.paginator = this.paginator;
          });



          // this.dataSource.paginator = this.paginator;
          // this.dataSource.sort = this.sort;
            }
            this.dataSource = new MatTableDataSource(this.dsCostHistoryObj);
            console.log(this.dataSource);
            console.log(this.dataSource.filteredData);
            //else{
            //}

           if(this.dsCostObj!=null){
            for (let i = 0; i < this.dsCostObj.length; i++) {
              if (this.dsCostObj[i].status != "Approved" && !this.dsCostObj[i].fmcstStatus.includes('Closed') && this.dsCostObj[i].status != "Rejected by BM") {
                this.approveEnable = true;
                break;
              }
            }
           }
           
            
           
          }
        
            else{
              this.defaultValueProduct='none';
              this.defaultValueCrop = 'block';
              this.dsCostObj = response.data.costapprovalmodel;
              this.dsCostInventoryObj = response.data.inventoryModel;
             
              if(this.dsCostObj!=null){
                for (let i = 0; i < this.dsCostObj.length; i++) {
                  if (this.dsCostObj[i].status != "Approved" && !this.dsCostObj[i].fmcstStatus.includes('Closed') && this.dsCostObj[i].status != "Rejected by BM") {
                    this.approveEnable = true;
                    break;
                  }
                }
               }
            }
          }
          else {
            this.toastr.error(response.message);
          }
          this.loader = 'none';
        }, error => {
        });
    }

  }
  
  applyFilter(filterValue) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.dataSource.filter = filterValue;
  }
  SaveCostApproval(saveCostApprove) {
    debugger;
    this.displayReject = 'none';
    let isValid = false;
    for (let i = 0; i < saveCostApprove.length; i++) {
      if (saveCostApprove[i].isSelected) {
        isValid = true;
        break;
      }
    }

    if (isValid) {
      this.selectedSaveCostApprove = [];
      this.singleSaveCostApprove = new SaveCostApproval();
      this.userId = localStorage.getItem('dsu_userId');
      let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
      // let requirmentType="";
      let requirmentType=this.requirmentType[0].text;
      // if(this.requirmentType.length>1){
      //   requirmentType='1,2';
      // }
      // else{  
      //   requirmentType = this.requirmentType[0].id;//Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.id; }).join(",");
      // }
      debugger;
      //let requirmentType = Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.id; }).join(",");
      this.loader = 'block';
      for (let i = 0; i < saveCostApprove.length; i++) {
        debugger;
        if (saveCostApprove[i].isSelected == true && saveCostApprove[i].status != 'Approved') {
          debugger;
          this.singleSaveCostApprove = new SaveCostApproval();

          this.singleSaveCostApprove.RequestId = saveCostApprove[i].requestId;
          this.singleSaveCostApprove.RequestDetailId=saveCostApprove[i].detailId ;
          this.singleSaveCostApprove.CostApprovalId = saveCostApprove[i].dsCostApprovalId;
          this.singleSaveCostApprove.productId=saveCostApprove[i].productId;
          this.singleSaveCostApprove.cropId=saveCostApprove[i].cropId;
          this.singleSaveCostApprove.packSize=saveCostApprove[i].packSize;
          this.singleSaveCostApprove.RequestedQTY = saveCostApprove[i].requestedQTY;
          this.singleSaveCostApprove.ApprovedQTY = saveCostApprove[i].finalApproveQTY.toString();
          this.singleSaveCostApprove.Remark = saveCostApprove[i].remarks;
          this.singleSaveCostApprove.status=saveCostApprove[i].status;
          this.singleSaveCostApprove.fmcstRemark = saveCostApprove[i].fmcstRemark;
          this.singleSaveCostApprove.fmcstStatus=saveCostApprove[i].fmcstStatus;

         
          // this.singleSaveCostApprove.Product = saveCostApprove[i].product;
          
          // this.singleSaveCostApprove.RequirementType = saveCostApprove[i].requirementType;
          // this.singleSaveCostApprove.RMHCode = saveCostApprove[i].rmhCode;
          // this.singleSaveCostApprove.RMHName = saveCostApprove[i].rmhName;
         
          // this.singleSaveCostApprove.WHLocation = saveCostApprove[i].whLocation;
          // this.singleSaveCostApprove.SD = saveCostApprove[i].sd;
          
          // this.singleSaveCostApprove.StockAvailable = saveCostApprove[i].stockAvailable;
          // this.singleSaveCostApprove.FinalQTY = saveCostApprove[i].finalQTY;
          
          // this.singleSaveCostApprove.TotalCost = parseFloat(saveCostApprove[i].totalCost).toFixed(2);
         
      
         
         
          
         
          this.selectedSaveCostApprove.push(this.singleSaveCostApprove);


        }
      }
      this.dsCostServices.SaveCostApproval(this.selectedSaveCostApprove, this.userId, requirmentType, year)
        .subscribe((response) => {
          if (response.status) {
            this.defaultView = false;
            this.tableView = false;
            this.approveEnable = false;
            //this.dsCostObj = response.data;
            this.toastr.success(response.message);
          }
          else {
            this.toastr.error(response.message);
          }
          this.GetCostApproval(0);
          this.loader = 'none';
        }, error => {
          this.loader = 'none';
          this.toastr.error('Some Problem Occured,Please try again later.');
        });

    }
    else {
      this.toastr.error('Please select RMH');
    }
   
  }


  DownloadExcel() {
    debugger;
    let requirmentType=this.requirmentType[0].text;
    // if(this.requirmentType.length>1){
    //   requirmentType='1,2';
    // }
    // else{  
    //   requirmentType = this.requirmentType[0].id;//Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.id; }).join(",");
    // }
    let isValid = true;
    let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    let rmh = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
    let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
    
    let status = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.text; }).join(",");
    let whCode = Array.prototype.map.call(this.warehouseLocation.selectedItems, function (item) { return item.id; }).join(",");
    
    if (typeof (requirmentType) == "undefined" || requirmentType == '') {
      this.toastr.error('Please select requirement type.');
      isValid = false;
      return false;
    }

    if (isValid) {
      this.loader = 'block';
      this.userId = localStorage.getItem('dsu_userId');
      let today = new Date();
      let month = '0' + (today.getMonth() + 1).toString().slice(-2);
      let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
      this.dsCostServices.DownloadExcel(this.userId, requirmentType, rmh, product,whCode,status,year)
        .subscribe(success => {
          if (success.ok = true) {
            var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
            saveAs(blob, this.userName +"_"+year+ "_DSCostApproval_" + formattedDate + ".xlsx");
          }
          this.loader = 'none';
        },
          err => {
            this.toastr.error("No data found");
            //alert("Some problem occurred while downloading file.");
            this.loader = 'none';
          });
    }
  }



  filesDroppedAdd(files: File[]) {
    debugger;
    this.files = [];
    this.files = files;
    let fileNameParts: string[] = files[0].name.split('.');
    let fileType = files[0].name.split('.')[fileNameParts.length - 1];
    let UserId = localStorage.getItem('dsu_userId');
    let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    let AnnualCycle=this.requirmentType[0].text;
    if (fileType != 'xls' && fileType != 'xlsx') {
      // this.snackBar.openSnackBar('Please Select Valid File Type.','Close','red-snackbar');
      this.toastr.error("Please select valid file type.");
      return false;
    }

    this.loader = 'block';
    var uploadedFile = <File>this.files[0];
    this.dsCostServices.UploadDocument(uploadedFile, UserId,year,AnnualCycle)
      .subscribe((resData: any) => {
        debugger
        if (resData.status) {
          this.toastr.success(resData.message);
          this.GetCostApproval(0);
        }
        else {
          this.toastr.error(resData.message);
        }
        this.defaultView = false;
        this.tableView = false;
        this.approveEnable = false;
        this.loader = 'none';
        this.file.nativeElement.value = '';
      }, error => {

        this.loader = 'none';
        this.file.nativeElement.value = '';
        this.toastr.error('Some Problem Occured,Please try again later.');
      });
  }


  textChange(newValue, reqtQty, nrv, i, id) {
    this.approveDisable = false;
    let nwValue = newValue.target.value;
    nwValue = parseFloat(nwValue);
    reqtQty = parseFloat(reqtQty);
    this.dsCostObj[i].totalCost = (nwValue * nrv).toFixed(2);

    let product = this.dsCostObj[i].product;
    let WareHouse = this.dsCostObj[i].whName;
    let StockAval = this.dsCostObj[i].stockAvailable;
    let TotalApprQty=this.dsCostObj[i].totalApprovedQty;
    // if (nwValue > reqtQty) {
    //   this.approveDisable = true;

    //   this.toastr.error('Final production approval quantity should not be greater than requested quantity.');
    //   return false;
    // }
    // else {
      let InvStockOriginal=0;
      let InvStockAvailable=0;

      // let InvtDetails = this.dsCostInventoryObj.find(x => x.productName === product && x.whLocation == WareHouse);
      // let InvStockOriginal = parseFloat(InvtDetails.stock);
      // let InvStockAvailable = parseFloat(InvtDetails.stock);
if(this.dsCostInventoryObj!=null){
      for(let InvtDetails=0;InvtDetails<this.dsCostInventoryObj.length;InvtDetails++){
        if(this.dsCostInventoryObj[InvtDetails].productName===product && this.dsCostInventoryObj[InvtDetails].whLocation===WareHouse){
          InvStockOriginal = parseFloat(this.dsCostInventoryObj[InvtDetails].stock);
          InvStockAvailable = parseFloat(this.dsCostInventoryObj[InvtDetails].stock);
        }
        
      }
    }

      let StockReduce = 0;

      let dsCostApprove = this.dsCostObj.filter(x => x.product == product && x.whName == WareHouse && x.id < id && x.status != 'Approved');
      let dsCostApproveAfter = this.dsCostObj.filter(x => x.product == product && x.whName == WareHouse && x.id >= id && x.status != 'Approved');
      for (let x = 0; x < dsCostApprove.length; x++) {
        StockReduce = StockReduce + dsCostApprove[x].stockAvailable;
      }
      InvStockAvailable = InvStockAvailable - StockReduce-TotalApprQty;

      if (InvStockAvailable <= 0) {
        for (let x = 0; x < dsCostApproveAfter.length; x++) {
          let dsId = dsCostApproveAfter[x].id;
          // dsId = parseInt(dsId) - 1;
          dsId = parseFloat(dsId) - 1;
          this.dsCostObj[dsId].stockAvailable = 0;
        }
      }
      else {
        if (nwValue > InvStockAvailable) {
          this.dsCostObj[i].stockAvailable = InvStockAvailable;
          for (let x = 0; x < dsCostApproveAfter.length; x++) {
            let dsId = dsCostApproveAfter[x].id;
              // dsId = parseInt(dsId) - 1;
              dsId = parseFloat(dsId) - 1;
            if (dsCostApproveAfter.length-1 == x) {
              this.dsCostObj[dsId].stockAvailable = InvStockAvailable;
            }
            else {
              
              if (i != dsId) {
                this.dsCostObj[dsId].stockAvailable = 0;
              }
            }
          }
        }
        else {
          if (dsCostApproveAfter.length == 1) {
            this.dsCostObj[i].stockAvailable = InvStockAvailable;
          }
          else{
            this.dsCostObj[i].stockAvailable = nwValue;
            InvStockAvailable = InvStockAvailable - nwValue;
          }
          for (let x = 0; x < dsCostApproveAfter.length; x++) {
            let dsId = dsCostApproveAfter[x].id;
            // dsId = parseInt(dsId) - 1;
            dsId = parseFloat(dsId) - 1;
            if (dsCostApproveAfter.length-1 == x) {
              this.dsCostObj[dsId].stockAvailable = InvStockAvailable;
            }
            else {

              // let reqQTY = parseInt(dsCostApproveAfter[x].requestedQTY);
              let reqQTY = parseFloat(dsCostApproveAfter[x].requestedQTY);
              if (i != dsId) {
                if (reqQTY >= InvStockAvailable) {
                  this.dsCostObj[dsId].stockAvailable = InvStockAvailable;
                  InvStockAvailable = 0;
                }
                else {
                  this.dsCostObj[dsId].stockAvailable = reqQTY;
                  InvStockAvailable = InvStockAvailable - reqQTY;
                }
              }
            }

          }
        }
      }

    //}
    let isApprove = true;
    for (let x = 0; x < this.dsCostObj.length; x++) {
      let reqQTY = this.dsCostObj[x].requestedQTY;
      let finalApprove = this.dsCostObj[x].finalApproveQTY;
      // reqQTY = parseInt(reqQTY);
      // finalApprove = parseInt(finalApprove);
      // if (reqQTY < finalApprove) {
      //   isApprove = false;
      //   this.approveDisable = true;
      //   break;
      // }
    }
    if(isApprove){
      this.approveDisable = false;
    }
  }

  isAlphaNumeric(event: any) {
    var newKeyCode = event.keyCode;
    return ((newKeyCode > 64 && newKeyCode < 91) || (newKeyCode > 96 && newKeyCode < 123) || (newKeyCode == 8 || newKeyCode == 32) || (newKeyCode >= 48 && newKeyCode <= 57) || newKeyCode == 59);
  }

  closePopup(commentModal: string) {
    this.displayReject = 'none';
  }
  openCommentPopup(saveCostApprove) {
    let isValid = false;
let issel=false;
    for (let i = 0; i < saveCostApprove.length; i++) {
      if (saveCostApprove[i].isSelected) {

        //  if( saveCostApprove[i].stockAvailable < saveCostApprove[i].finalApproveQTY){
        //   //this.approveDisable=true;
        //   this.toastr.error('Final production approval quantity should not be greater than stock available.');
        //   return false;
        // }
        // else{
        //   //this.approveDisable=false;
        //   isValid = true;
        //   break;
        // }
        issel=true;
        if (saveCostApprove[i].finalApproveQTY == null){
          isValid = true;
          this.toastr.error('Please enter the quantity to proceed.');
          break;
        }
        if (saveCostApprove[i].finalApproveQTY > 0){
          isValid = true;
          break;
        }
        else{ if(saveCostApprove[i].finalApproveQTY == 0 && saveCostApprove[i].totalApprovedQty > 0)
            {
              isValid=false;
              this.toastr.error('Please enter a value greater than 0 for partial approved requests.');
              break;
            }
            else if (saveCostApprove[i].finalApproveQTY == 0 && saveCostApprove[i].totalApprovedQty == 0)
            {
              isValid = true;
              break;
            }
          }
        //isValid = true;
      }
      
      
    }
    if (isValid) {
      this.displayReject = 'block';
    }
    else if(!issel){
      this.toastr.error('Please select at least one request before proceeding');
    }
    
  }

  reset() {
    //location.reload();
    this.defaultValue = 'none';
    if (this.requirmentType != undefined) {
      this.requirmentType.selectedItems = [];
    }
    if (this.rmh != undefined) {
      this.rmh.selectedItems = [];
    }
    if (this.productSelect != undefined) {
      this.productSelect.selectedItems = [];
    }
    if (this.cropSelect != undefined) {
      this.cropSelect.selectedItems = [];
    }
    if (this.sbu != undefined) {
      this.sbu.selectedItems = [];
    }
    if (this.division != undefined) {
      this.division.selectedItems = [];
    }
    if (this.zone != undefined) {
      this.zone.selectedItems = [];
    }
    if (this.regionSelect != undefined) {
      this.regionSelect.selectedItems = [];
    }
    if (this.warehouseLocation != undefined) {
      this.warehouseLocation.selectedItems = [];
    }
  }


  DownloadExcelForAdmin() {
    let requirmentType = Array.prototype.map.call(this.requirmentType, function (item) { return item.text; }).join(",");
    let isValid = true;
    let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
    let rmh = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
    let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
    let sbu = Array.prototype.map.call(this.sbu.selectedItems, function (item) { return item.id; }).join(",");
    let division = Array.prototype.map.call(this.division.selectedItems, function (item) { return item.id; }).join(",");
    let zone = Array.prototype.map.call(this.zone.selectedItems, function (item) { return item.id; }).join(",");
    let region = Array.prototype.map.call(this.regionSelect.selectedItems, function (item) { return item.id; }).join(",");
    let crop=Array.prototype.map.call(this.CropSelect.selectedItems, function (item) { return item.id; }).join(",");
    let status = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.text; }).join(",");
    let whCode = Array.prototype.map.call(this.warehouseLocation.selectedItems, function (item) { return item.id; }).join(",");
    
    if (typeof (requirmentType) == "undefined" || requirmentType == '') {
      this.toastr.error('Please select requirement type.');
      isValid = false;
      return false;
    }
    if (isValid) {

      this.loader = 'block';
      this.userId = localStorage.getItem('dsu_userId');
      let today = new Date();
      let month;
      if((today.getMonth() + 1)<10)
      {
        month = '0' + (today.getMonth() + 1).toString().slice(-2);
      }
      else
      {
        month =  (today.getMonth() + 1).toString().slice(-2);
      }
      let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
      this.dsCostServices.DownloadExcelForAdmin(this.userId, requirmentType, rmh, product,whCode,status,year,sbu,division,zone,region,crop)
        .subscribe(success => {
          if (success.ok = true) {
            var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
            saveAs(blob, this.userName + "_" + year + "_DSCostApproval_" + formattedDate + ".xlsx");
          }
          this.loader = 'none';
        },
          err => {
            this.toastr.error("No data found");
            //alert("Some problem occurred while downloading file.");
            this.loader = 'none';
          });
    }
  }
  SelectDisselectAll(ev) {
    this.dsCostObj.forEach(x => x.isSelected = ev.target.checked)
  }

  isAllChecked() {
    return this.dsCostObj.every(_ => _.isSelected);
  }
  setSubMenu(event: any, type: string): void {
    this.tabName = type;
    this.GetCostApproval(1);
}
DownloadExcelCropwise() {
  let requirmentType="";
    if(this.requirmentType.length>1){
      requirmentType='1,2';
    }
    else{  
      requirmentType = this.requirmentType[0].id;//Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.id; }).join(",");
    }
  //let requirmentType = Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.id; }).join(",");
  let isValid = true;
  let rmh = Array.prototype.map.call(this.rmh.selectedItems, function (item) { return item.id; }).join(",");
  let product = Array.prototype.map.call(this.productSelect.selectedItems, function (item) { return item.id; }).join(",");
  let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
  let status = Array.prototype.map.call(this.status.selectedItems, function (item) { return item.text; }).join(",");
  let whCode = Array.prototype.map.call(this.warehouseLocation.selectedItems, function (item) { return item.id; }).join(",");
  
  if (typeof (requirmentType) == "undefined" || requirmentType == '') {
    this.toastr.error('Please select requirement type.');
    isValid = false;
    return false;
  }

  if (isValid) {
    this.loader = 'block';
    this.userId = localStorage.getItem('dsu_userId');
    let today = new Date();
    let month = '0' + (today.getMonth() + 1).toString().slice(-2);
    let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
    this.dsCostServices.DownloadExcelCropwise(this.userId, requirmentType, rmh, product,whCode,status,year)
      .subscribe(success => {
        if (success.ok = true) {
          var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
          saveAs(blob, this.userName + "_" + year + "_DSCostApproval_" + formattedDate + ".xlsx");
        }
        this.loader = 'none';
      },
        err => {
          this.toastr.error("No data found");
          //alert("Some problem occurred while downloading file.");
          this.loader = 'none';
        });
  }
}
DownloadExcelForAdminCropwise() {
  let requirmentType="";
    if(this.requirmentType.length>1){
      requirmentType='1,2';
    }
    else{  
      requirmentType = this.requirmentType[0].id;//Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.id; }).join(",");
    }
  //let requirmentType = Array.prototype.map.call(this.requirmentType.selectedItems, function (item) { return item.id; }).join(",");
  let isValid = true;
  let year = Array.prototype.map.call(this.year.selectedItems, function (item) { return item.id; }).join(",");
  if (typeof (requirmentType) == "undefined" || requirmentType == '') {
    this.toastr.error('Please select requirement type.');
    isValid = false;
    return false;
  }
  if (isValid) {

    this.loader = 'block';
    this.userId = localStorage.getItem('dsu_userId');
    let today = new Date();
    let month = '0' + (today.getMonth() + 1).toString().slice(-2);
    let formattedDate = today.getDate() + "_" + month + "_" + today.getFullYear();
    this.dsCostServices.DownloadExcelCropwiseForAdmin(this.userId, requirmentType,year)
      .subscribe(success => {
        if (success.ok = true) {
          var blob = new Blob([success.blob()], { type: 'application/vnc.openxmlformats-officedocument.spreadsheetxml.sheet' })
          saveAs(blob, this.userName + "_" + year + "_DSCostApproval_" + formattedDate + ".xlsx");
        }
        this.loader = 'none';
      },
        err => {
          this.toastr.error("No data found");
          //alert("Some problem occurred while downloading file.");
          this.loader = 'none';
        });
  }
}

}
/**Creating interface for Cost Approval History data **/


export interface CostApprovalHistoyData {
  requirementType:string;
  rmhName:string;
  productName: string;
  finalProductQtyApproved: string;
  approvedOn: string;
  comment:string;
  year:number;
}

